




















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  // components: {
  //   CHeader,
  //   CSidebar
  // }
})
export default class AppMain extends Vue {
}
